<template>
  <div>
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1>Leads</h1>
    </div>

    <b-row>
      <b-col md="4">
        <b-button variant="success" @click="csvExport(csvData)"><i class="fa fa-download" aria-hidden="true"></i> Export to CSV</b-button>
      </b-col>
      <b-col md="5" class="my-1 mb-2">
        <b-form-group label-cols-sm="3" label="Filtrer" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to filter"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3" class="my-1">
        <b-form-group label-cols-sm="5" label="Per page" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-table striped borderless head-variant=dark hover :items="all_leads" :fields="fields" :filter="filter" :current-page="currentPage" :per-page="perPage"  @filtered="onFiltered">

    </b-table>

    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>


  </div>

</template>

<script>

  import { mapGetters, mapActions, mapMutations } from 'vuex';
  export default {

    name: 'admin_leads',

    data() {
      return {
        // Note `isActive` is left out and will not appear in the rendered table
        fields: [
          {
            key: 'email',
            sortable: true
          },
          {
            key: 'firstName',
            sortable: true
          },
          {
            key: 'lastName',
            sortable: true
          },
          {
            key: 'roleAtCompany',
            label: 'Occupation',
          },
          {
            key: 'company',
            sortable: true
          },
          {
            key: 'projectDeadline',
            sortable: false
          },
          {
            key: 'meta.created_at',
            sortable: true
          },
        ],
        currentPage: 1,
        filter: null,
        filteredItems: [],
        pageOptions: [5, 10, 50, 100, 250],
        perPage: 5,
      }
    },

    computed: {

      ...mapGetters('lead', {
        all_leads: 'list'
      }),

      totalRows: function () {
        console.log(this.filteredItems.length !== 0);
        if (this.filteredItems.length !== 0) {
          return this.filteredItems.length;
        } else {
          console.log("HERE");
          return this.all_leads.length;
        }
      },

      csvData() {
        // Prepare leads to be CSV exported
        // We export the disaplyed leads (all_leads or filtered_leads based on current situation)
        var dataArr;
        if (this.filteredItems.length !== 0) {
          dataArr = this.filteredItems
        } else {
          dataArr = this.all_leads
        }

        // see https://stackoverflow.com/a/35922654
        const exportedArr = dataArr.map(item => ({
          ...item,
          priorities: 'not available in export yet',
          meta: 'not available in export yet',
          }));
        return exportedArr;
      }
    },

    created() {
      this.findLeads();
    },

    methods: {
      ...mapActions('lead', {
        findLeads: 'list'
      }),

      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.filteredItems = filteredItems;
        this.currentPage = 1;
      },

      csvExport(arrData) {
        // see https://codepen.io/dimaZubkov/pen/eKGdxN
        let csvContent = "data:text/csv;charset=utf-8,";
        csvContent += [
          Object.keys(arrData[0]).join(";"),
          ...arrData.map(item => Object.values(item).join(";"))
        ]
          .join("\n")
          .replace(/(^\[)|(\]$)/gm, "");

        const data = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", data);
        link.setAttribute("download", "export.csv");
        link.click();
      }
    }

  }
</script>





// WEBPACK FOOTER //
// src/pages/admin/AdminLeadsPage.vue